export const FooterDisclaimer = () => {
  return (
    <div className="text-color-text-weakest mx-auto mt-auto mb-6 flex flex-row items-center justify-center gap-2 p-4 text-sm font-semibold tracking-wide">
      <span>Powered by</span>
      <div className="aspect-[4.85] h-[20px]">
        <img alt="BlockG" src="/blockg.png" />
      </div>
    </div>
  );
};
